import React from 'react';
import {hashHistory} from 'react-router';
import Close from 'material-ui/svg-icons/content/clear';
import {Carousel, CarouselItem, Modal, ModalBody} from 'react-bootstrap';

const styles = {
  modal: {
    // backgroundColor:'rgba(0,0,0,0.6) !important',
    width: '100%',
    padding: '0 !important'
  },
  modalHeaderClose: {
    position: 'fixed',
    top:'-15px',
    right: '-15px',
    cursor: 'pointer',
    margin: '5px',
    fontWeight: 'bold',
    zIndex:'1',
    background:'black',
    color:'white',
    border: '1px black solid',
    borderRadius:'100px'
  }
};

class StationImage extends React.Component {
  render() {
    const close = () => {
      hashHistory.push(this.props.slug);
    };
    return (
      <Modal
        show={true}
        onHide={close}
        style={{width:''}}>
        <ModalBody style={{maxHeight:'90vh'}} className="inline-it">
          <Close style={styles.modalHeaderClose} onClick={close}>X</Close>
          <Carousel animation={true} indicators={true} slide={true}>
            {this.props.images.map((image, i) => (
              <CarouselItem key={i} style={{height:'100%'}}>
                <img style={{maxHeight:'85vh'}} src={`http://daq.hydrology.gov.np/images/${image.name}`} alt="not found"/>
              </CarouselItem>
            ))}
          </Carousel>
        </ModalBody>
      </Modal>
    );
  }
}

export default StationImage;


// WEBPACK FOOTER //
// ./src/components/Station/StationImage.js